export const pluralise = (count: number, singular: string, plural = `${singular}s`) =>
  count === 1 ? singular : plural;

export const formatCount = (value: number) => value.toLocaleString("en-GB");

export const formatCountOf = (count: number, singular: string, plural?: string) =>
  `${formatCount(count)} ${pluralise(count, singular, plural)}`;

export const joinWithOr = (names: string[]) =>
  names.length < 2 ? names.join("") : `${names.slice(0, -1).join(", ")} or ${names[names.length - 1]}`;
